/**
 * Format a raw Unifreight file number (e.g. "A00100688") for display as "A/100688".
 */
export function formatUnfFileNoDisplay(raw?: string | null): string {
    if (!raw) return '-';
    const match = raw.match(/^([A-Za-z]+)0*(\d+)$/);
    if (!match) return raw;
    return `${match[1]}/${match[2]}`;
}
